var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocUpload24 = function SvgDocUpload24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.288 8.297A1.007 1.007 0 0 1 8 8a.997.997 0 0 1 .707.293l2 2A1 1 0 0 1 10 12H9v3a1 1 0 1 1-2 0v-3H6a1 1 0 0 1-.707-1.707l1.995-1.996Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5a5 5 0 0 1 5-5h3.597a5 5 0 0 1 3.123 1.096l2.403 1.922A5 5 0 0 1 16 6.923V15a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Zm5-3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6.922A3 3 0 0 0 13.855 6H11a2 2 0 0 1-2-2V2.027A3 3 0 0 0 8.597 2H5Z",
    fill: "#242424"
  })));
};
export default SvgDocUpload24;